<template>
  <div class="event-add ccs-fields">
    <div class="ccs-field ccs-12">
      <div class="field-name">
        О мероприятии
      </div>
      <ccs-input id="description" class="field-value ccs-12" type="textarea"
        v-model="eventAddInfo.description" :readOnly="!editing"/>
      <!--<div v-if="permissionsStatus.isEventUpdateAllowed"
        class="ccs-button ccs-button--white">
        <img src="@/assets/icons/gear_blue.svg" alt="" class="button-icon">
        Настроить доп. поля
      </div>-->
    </div>
    <!--<div class="ccs-field">
      <div class="field-name">
        Дополнительное поле
      </div>
      <div class="field-value">
        Nam sodales elementum dolor non semper.
      </div>
    </div>-->
    <div class="ccs-layout ccs-layout--no-pad">
      <div v-if="!editing" class="info-button">
        <button v-if="permissionsStatus.isEventUpdateAllowed"
          class="ccs-button" @click="switchEditing">
          Редактировать
        </button>
      </div>
      <div v-else class="info-button">
        <button class="ccs-button" @click="confirmEditing">
          Сохранить изменения
        </button>
      </div>
      <div v-if="editing">
        <button class="ccs-button ccs-button--light" @click="cancelEditing">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'AddInfo',
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      editing: false,
      eventAddInfo: {
        id: 0,
        description: '',
      },
    };
  },
  computed: {
    ...mapState('events', ['event']),
    ...mapGetters('session', ['permissionsStatus']),
  },
  methods: {
    ...mapActions('events', ['updateEvent']),
    async confirmEditing() {
      try {
        await this.updateEvent(this.eventAddInfo);
        this.$toasted.success('Изменения сохранены');
        this.switchEditing();
      } catch (err) {
        this.$toasted.error(err.message);
        this.cancelEditing();
      }
    },
    switchEditing() {
      this.editing = !this.editing;
    },
    cancelEditing() {
      this.resetEventAddInfo();
      this.switchEditing();
    },
    resetEventAddInfo() {
      this.eventAddInfo = {
        id: this.event.id,
        description: this.event.description,
      };
    },
  },
  watch: {
    event: {
      immediate: true,
      handler(event) {
        this.eventAddInfo = {
          id: event.id,
          description: event.description,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.event-add {
  min-height: 100%;
  min-width: 100%;
  background: #fff;

  .info-button {
    padding-left: 0;
  }

  #description {
    margin-right: 30px;
  }

}
</style>
